import React from 'react'
import { Taxonomies } from 'starterComponents'

export const PostEntryMeta = ({ post, ...props }) => {
  return (
    <div className="entry-meta">
      <Taxonomies post={post} taxName="categories" singularName="category" />
      <Taxonomies post={post} taxName="tags" singularName="tag" />
    </div>
  )
}
